import { ForEach, If } from "@components/control-statements";
import { VariableSchema } from "@containers/oraculo/VariableSchema";
import { LogicalOperandTexts } from "@core/oraculo";
import style from "@styles/pages/oraculo/base-node.module.scss";
import React from "react";
import { Clause } from "./Clause";
import { Scope } from "./Scope";

const LogicalConnector = ({ operand, onClick }) => (
  <div className={style.connector} onClick={(e) => onClick(e)}>
    <div className={style.andOr}>
      <span>{LogicalOperandTexts[operand || "and"]}</span>
      <i className="far fa-shuffle" />
    </div>
  </div>
);

export const TreeClauses = ({ data, valueType, onClick }) => {
  const valid_clauses =
    data.items?.map((c) => VariableSchema.countValidClauses(c)) || [];
  const last_valid_count = valid_clauses[valid_clauses.length - 1] || 0;

  const filtered_items =
    data.items.filter((i) => {
      if (VariableSchema.countValidClauses(i) > 0) {
        return true;
      }
      return false;
    }) || [];

  const toggle = (e) => {
    return onClick(e, {
      action: "apply",
      target: "node",
      data: { operand: data.operand == "or" ? "and" : "or" },
    });
  };

  return (
    <>
      <ForEach
        items={filtered_items}
        render={(item, index) => {
          return (
            <>
              <If cond={item.type == "scope"}>
                <Scope
                  scope={item}
                  valueType={valueType}
                  onClick={onClick}
                  className={style.card}
                />
              </If>
              <If cond={item.type != "scope"}>
                <Clause clause={item} valueType={valueType} onClick={onClick} />
              </If>
              <If cond={index < filtered_items.length - 1}>
                <LogicalConnector operand={data.operand} onClick={toggle} />
              </If>
            </>
          );
        }}
      />
      <If cond={last_valid_count > 0}>
        <div
          className={style.plus}
          onClick={(e) => onClick(e, { action: "add", target: null })}
        >
          <i className="fas fa-plus" />
        </div>
      </If>
    </>
  );
};
